import {
  jb_time_css_default
} from "./chunk.G3QWAAVU.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-time/jb-time.ts
var JbTime = class extends r {
  render() {
    return ke`<time>${this.time ? ke`<jb-clock-icon></jb-clock-icon><span>${this.time}</span>` : D}</time>`;
  }
};
JbTime.styles = [reset_css_default, jb_time_css_default];
__decorateClass([
  n()
], JbTime.prototype, "time", 2);
JbTime = __decorateClass([
  customElement("jb-time")
], JbTime);

export {
  JbTime
};
